/** @jsx jsx */
import Link from '../../components/shared/Typography/Link/Link'
import Body from '../../components/shared/Typography/Body/Body'
import styled from '@emotion/styled'
import { jsx, Flex } from 'theme-ui'
import React from 'react'
import { mobile } from '../../components/shared/index'
import twitter from '../../icons/twitter.png'
import instagram from '../../icons/ig.png'
import facebook from '../../icons/fb.png'
import pinterest from '../../icons/pinterest.png'

const LogoWrapper = styled(Flex)``

const Logo = styled.img`
  width: 30px;
  margin: 10px 20px 0px 0px;
`

const SocialLink = props => {
  return (
    <>
      <Body
        variant="body2Bold"
        sx={{
          textTransform: 'uppercase',
          textAlign: ['center', 'center', 'right'],
        }}
      >
        {props.title}
      </Body>

      <LogoWrapper
        sx={{
          justifyContent: ['center', null, 'flex-end'],
          mb: ['40px', null, '70px'],
        }}
      >
        <Link to="https://www.instagram.com/jaxxon/">
          <Logo src={instagram} />
        </Link>
        <Link to="https://www.facebook.com/JaxxonCo/">
          <Logo src={facebook} alt={'AmexLogo'} />
        </Link>
        <Link to="https://twitter.com/JaxxonCo">
          <Logo src={twitter} />
        </Link>
        <Link to="https://in.pinterest.com/JaxxonCo/">
          <Logo src={pinterest} sx={{ marginRight: '0px' }} />
        </Link>
      </LogoWrapper>
    </>
  )
}

export default SocialLink
